import ForcedUpgrade from './Page/ForcedUpgrade';
export { makeApiMiddleware } from './ApiMiddleware';
export const Pages = { ForcedUpgrade };
